var moment = require('moment')

export default class {
  constructor (model) {
    this.id = model.id
    this.date = moment(model.date, 'YYYYMMDD')
    this.label = model.label
    this.language = model.language
    this.booked = model.booked
    this.isAutoAffected = model.isAutoAffected
    this.isSelectable = model.isSelectable
  }

  get formatedDate () {
    return this.date.format('L')
  }
}
